import { Component, OnInit } from "@angular/core";
import { Version } from "../versions/version";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  uiVersion: Version;

  apiVersion: BehaviorSubject<Version>;

  constructor(private http: HttpClient) {
  }

  ngOnInit(): void {
    this.http.get<Version>(`${environment.apiUrl}/version`).subscribe({
      next: (data) => {
        this.apiVersion = new BehaviorSubject<Version>(data);
      },
      error: (err) => console.error("Failed to load API version", err)
    });
  }
}
